import { h } from "preact";
import Navbar from "./common/navbar";
import Header from "./common/header";
import { styled } from "@mui/material/styles";

const Container = styled("div")`
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  .navbarWrapper {
    height: 100%;
    position: fixed;
  }
  .contentWrapper {
    color: #fff;
    padding: 0 30px;
    background-color: black;
    flex: 1;
    min-width: 0;
    overflow-y: auto;
  }
  .childWrapper {
    // padding: 10px;
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  @media only screen and (max-width: 724px) {
    .contentWrapper {
      padding: 10px 10px 10px 16px;
    }
  }
`;

const DashboardContentWrapper = ({
  children,
  pendingSongRequestsList = null,
}) => {
  return (
    <Container>
      <Navbar className="navbarWrapper" />
      <div className="contentWrapper">
        <Header pendingSongRequestsList={pendingSongRequestsList} />
        <div className="childWrapper">{children}</div>
      </div>
    </Container>
  );
};

export default DashboardContentWrapper;
